import { axiosRequest } from '@/plugins/axios-common'
import { handleError } from '@/store/handle-error'

export const UploadLinksState = {
  UploadLinks: {
    enabled: false,
  },
}

export const UploadLinksActions = {
  checkDocketEntryUploadLinksEnabled: async ({ commit }) => {
    return axiosRequest.get('/docket_entries/upload_links/enabled').
      then(({ data }) => commit('setDocketEntryUploadLinksEnabled', data.enabled)).
      catch(handleError)
  },

  createDocketEntryUploadLink: async ({ commit }, { instructions, docketEntryId }) => {
    return axiosRequest.
      post(`/docket_entries/${docketEntryId}/upload_link`, { instructions }).
      then(({ data }) => {
        commit('rehydrateDocketEntryModel', { docketEntryId, data: data.docket_entry }, { root: true })
      }).
      catch(handleError)
  },

  shareDocketEntryUploadLink: async (_, { channel, docketEntryId, partyId }) => {
    return axiosRequest.
      post(`/docket_entries/${docketEntryId}/upload_link/share`, {
        channel,
        party_id: partyId,
      }).
      then(({ data }) => data).
      catch(handleError)
  },
}

export const UploadLinksMutations = {
  setDocketEntryUploadLinksEnabled: (state, data) => (state.UploadLinks.enabled = data),
}

export const UploadLinksGetters = {
  docketEntryUploadLinksEnabled: state => state.UploadLinks.enabled,
}
